export const defaultCarouselCardWidth = 400;
export const defaultCarouselCardWidthMobile = 300;
export const defaultCarouselCardSpacing = 24;

export const defaultSmallCarouselCardWidth = 300;
export const defaultSmallCarouselCardWidthMobile = 225;
